/** init domain config */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './router/router'
import './assets/js/element.js'
import './assets/js/ant.js'
import watermark from './utils/watermark.js'
Vue.prototype.$watermark = watermark

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)



import base from './assets/js/base.js'
Vue.prototype.$base = base
import Storage from 'vue-ls'
import '@wangeditor/editor/dist/css/style.css'
import {
  regionData
} from "element-china-area-data";
Vue.prototype.$Jpcaa = regionData
import {
  uuid
} from "vue-uuid";
Vue.prototype.$uuid = uuid
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;
import 'swiper/css/swiper.css';
// vue-ls 的配置
const storageOptions = {
  namespace: 'vue_', // key 键的前缀（随便起）
  name: 'ls', // 变量名称（随便起） 使用方式：Vue.变量名称 或 this.$变量名称
  storage: 'local' // 作用范围：local、session、memory
}
import JDictSelectTag from './components/index.js'
Vue.use(JDictSelectTag)
Vue.use(Storage, storageOptions)
Vue.prototype.$Ls = Vue.ls

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')